module.exports = __webpack_public_path__ + "img/编组 53.a7fb7e89.png";